<template>
  <div class="kft-horizontal-scroll-wrapper w-full">
    <div class="kft-horizontal-scroll-wrapper__container">
      <div
        v-show="
          itemsLength > 1 &&
          scrollableContainerRef &&
          (scrollableContainerRef.scrollLeft === 0 ||
            scrollableContainerRef.scrollLeft +
              scrollableContainerRef.offsetWidth <
              scrollableContainerRef.scrollWidth - 50)
        "
        class="kft-horizontal-scroll-wrapper__right-arrow"
        @click="
          scrollableContainerRef?.scrollTo({
            left:
              (scrollableContainerRef?.scrollLeft || 0) +
              (scrollableContainerRef?.offsetWidth || 0),
            behavior: 'smooth',
          })
        "
      >
        <div
          class="kft-horizontal-scroll-wrapper__arrow-container flex justify-center items-center"
        >
          <IconChevronDown class="-rotate-90 mt-1 text-black" />
        </div>
      </div>
      <div
        v-show="shadowContainerScrollLeft > 50 && itemsLength > 1"
        class="kft-horizontal-scroll-wrapper__left-arrow"
        @click="
          scrollableContainerRef?.scrollTo({
            left:
              (scrollableContainerRef?.scrollLeft || 0) -
              (scrollableContainerRef?.offsetWidth || 0),
            behavior: 'smooth',
          })
        "
      >
        <div
          class="kft-horizontal-scroll-wrapper__arrow-container flex justify-center items-center"
        >
          <IconChevronDown class="rotate-90 mt-1 text-black" />
        </div>
      </div>
      <div
        ref="scrollableContainerRef"
        v-dragscroll.x
        class="flex gap-4 flex-nowrap kft-horizontal-scroll-wrapper__cards-container py-3"
        data-test-id="horizontal-scroll-wrapper"
        @dragscrollstart="onDragStart"
        @scroll.passive="fnHandleShadowScroll"
        @click.capture="onDragClick"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { dragscroll } from 'vue-dragscroll'
import IconChevronDown from '~/components/icons/IconChevronDown.vue'

export default {
  directives: { dragscroll },
  components: { IconChevronDown },
  props: {
    itemsLength: {
      type: Number,
      required: true,
    },
  },
  emits: ['click'],
  setup() {
    /* This is so we can track scrolling  */
    const scrollableContainerRef = ref<HTMLElement | null>(null)
    const shadowContainerScrollLeft = ref(0)
    const dragged = ref(false)
    const dragTimeout = ref<ReturnType<typeof setTimeout> | null>(null)

    /**
     ** @name fnHandleShadowScroll
     ** @desc The function handles scrolling on a shadowed container
     ** @param e Scroll event
     **/
    const fnHandleShadowScroll = (e: Event) => {
      const target = e.target as HTMLElement
      shadowContainerScrollLeft.value = target.scrollLeft
    }

    const onDragStart = () => {
      if (dragTimeout.value) {
        clearTimeout(dragTimeout.value)
      }

      dragged.value = false
      dragTimeout.value = setTimeout(() => {
        dragged.value = true
      }, 100)
    }

    const onDragClick = (e: Event) => {
      if (dragged.value) {
        e.preventDefault()
      }

      dragged.value = false
    }

    return {
      shadowContainerScrollLeft,
      fnHandleShadowScroll,
      onDragStart,
      onDragClick,
      scrollableContainerRef,
    }
  },
}
</script>

<style lang="css" scoped>
.kft-horizontal-scroll-wrapper__cards-container {
  overflow: hidden;
  max-width: calc(100vw - 2rem);
}
.kft-horizontal-scroll-wrapper__cards-container::-webkit-scrollbar {
  display: none;
}
.kft-horizontal-scroll-wrapper__container {
  position: relative;
}
.kft-horizontal-scroll-wrapper__arrow-container {
  cursor: pointer;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  z-index: 2;
  width: 42px;
  height: 42px;
  position: relative;
}
.kft-horizontal-scroll-wrapper__arrow-container i {
  display: block;
  line-height: 42px;
  text-align: center;
}
.kft-horizontal-scroll-wrapper__right-arrow,
.kft-horizontal-scroll-wrapper__left-arrow {
  content: '';
  height: 100%;
  width: 50px;
  top: 0;
  position: absolute;
}
.kft-horizontal-scroll-wrapper__right-arrow {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  right: -10px;
  background: linear-gradient(to right, rgba(0, 0, 0, 0), var(--color-white));
}
.kft-horizontal-scroll-wrapper__left-arrow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  left: 0;
  background: linear-gradient(to right, var(--color-white), rgba(0, 0, 0, 0));
}
</style>
